import { ArrowDropDown } from "@mui/icons-material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import {
  reportsNavigationDrawerAtom,
  TOOLTIP_DELAY_BUTTONS,
} from "@ryde/shared";
import { deepPurpleMui, greyMui } from "@ryde/theme";

import { ReportToggleButtonStyled } from "./report-navigation.styled";

export const ReportNavigationToggleButton: FC = () => {
  const [reportMenuOpen, setReportMenuOpen] = useRecoilState(
    reportsNavigationDrawerAtom,
  );
  const { t } = useTranslation();

  const onClick = (): void => {
    setReportMenuOpen(prevState => !prevState);
  };

  const color = useMemo(() => {
    return reportMenuOpen ? greyMui._600 : deepPurpleMui.A700;
  }, [reportMenuOpen]);

  return (
    <FramerTooltip
      content={t("ui.TOGGLE_REPORT_MENU")}
      mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
    >
      <ReportToggleButtonStyled onClick={onClick}>
        <SVG_MUI.ReportsIconSVG
          fill={color}
          className="ReportToggleButtonSVG"
        />
        <label style={{ color }}>{t("ui.TOGGLE_REPORT_MENU")}</label>
        <ArrowDropDown />
      </ReportToggleButtonStyled>
    </FramerTooltip>
  );
};
